export default __webpack_public_path__ + "static/media/no-friend-requests-icon.2e0b399d.svg";